@if ({main: main$ | async, favorites: favorites$ | async, activeIds: activeIds$ | async, starred: starredKeys$ | async}; as vm) {
  <ul class="navbar-nav me-auto menu-items sn-top-menu">
    <ng-content></ng-content>

    @if (!compact) {
      @if (vm.favorites?.length) {
      <li class="nav-item dropdown collapsible-nav-item sn-top-menu__favorites"
          [class.show]="openId === FAVORITES"
          (mouseenter)="hoverOpen(FAVORITES)" (mouseleave)="hoverClose(FAVORITES)">
        <button type="button" class="nav-link dropdown-toggle sn-top-menu__toggle" [attr.data-sn-toggle]="FAVORITES"
                aria-haspopup="true" [attr.aria-expanded]="openId === FAVORITES" aria-label="Favorites" title="Favorites"
                (click)="toggle(FAVORITES)" (keydown)="onToggleKeydown($event, FAVORITES)">
          <i class="fa-solid fa-star" aria-hidden="true"></i>
        </button>
        <div class="dropdown-menu sn-top-dropdown" [attr.data-sn-menu]="FAVORITES">
          <ng-container *ngTemplateOutlet="favoriteItems; context: {$implicit: vm.favorites}"></ng-container>
        </div>
      </li>
      }

      @for (node of vm.main; track trackById($index, node)) {
        @if (node.type === 'link') {
        <li class="nav-item collapsible-nav-item">
          @if (!node.external) {
          <a class="nav-link" [class.active-link]="vm.activeIds.has(node.id)"
             [attr.aria-current]="vm.activeIds.has(node.id) ? 'page' : null"
             [routerLink]="node.path" [queryParams]="node.queryParams">{{ node.label | uppercase }}</a>
          }
          @if (node.external) {
          <a class="nav-link" [href]="node.href" target="_blank" rel="noopener noreferrer">
            {{ node.label | uppercase }}<span class="visually-hidden"> (opens in a new tab)</span>
          </a>
          }
        </li>
        }
        @if (node.type === 'group') {
        <li class="nav-item dropdown collapsible-nav-item"
            [class.show]="openId === node.id"
            (mouseenter)="hoverOpen(node.id)" (mouseleave)="hoverClose(node.id)">
          <button type="button" class="nav-link dropdown-toggle sn-top-menu__toggle" [attr.data-sn-toggle]="node.id"
                  [class.active-link]="vm.activeIds.has(node.id)" aria-haspopup="true"
                  [attr.aria-expanded]="openId === node.id"
                  (click)="toggle(node.id)" (keydown)="onToggleKeydown($event, node.id)">
            {{ node.label | uppercase }}
          </button>
          <div class="dropdown-menu sn-top-dropdown" [attr.data-sn-menu]="node.id">
            <ng-container *ngTemplateOutlet="items; context: {$implicit: node.children, vm: vm}"></ng-container>
          </div>
        </li>
        }
      }
    } @else {
      <li class="nav-item dropdown top-menus-overflow" [class.show]="openId === COMPACT"
          (mouseenter)="hoverOpen(COMPACT)" (mouseleave)="hoverClose(COMPACT)">
        <button type="button" class="nav-link dropdown-toggle sn-top-menu__toggle" [attr.data-sn-toggle]="COMPACT"
                aria-haspopup="true" [attr.aria-expanded]="openId === COMPACT"
                (click)="toggle(COMPACT)" (keydown)="onToggleKeydown($event, COMPACT)">MENU</button>
        <div class="dropdown-menu sn-top-dropdown sn-top-dropdown--compact" [attr.data-sn-menu]="COMPACT">
          @if (vm.favorites?.length) {
            <h6 class="dropdown-header sn-top-dropdown__heading">Favorites</h6>
            <ng-container *ngTemplateOutlet="favoriteItems; context: {$implicit: vm.favorites}"></ng-container>
            <div class="dropdown-divider"></div>
          }
          <ng-container *ngTemplateOutlet="items; context: {$implicit: vm.main, vm: vm}"></ng-container>
        </div>
      </li>
    }

  </ul>

  <!-- Off-screen copy of the top-level entries at their natural width, for the compact switch. -->
  <div class="nav-overflow-measure" aria-hidden="true" #measure>
    @if (vm.favorites?.length) {
    <span class="nav-overflow-measure__item">
      <span class="nav-link dropdown-toggle"><i class="fa-solid fa-star"></i></span>
    </span>
    }
    @for (node of vm.main; track trackById($index, node)) {
    <span class="nav-overflow-measure__item">
      <span class="nav-link" [class.dropdown-toggle]="node.type === 'group'">{{ node.label | uppercase }}</span>
    </span>
    }
  </div>

  <ng-template #items let-nodes let-vm="vm">
    @for (node of nodes; track trackById($index, node)) {
      @if (node.type === 'divider') {
      <div class="dropdown-divider" role="separator"></div>
      }
      @if (node.type === 'group') {
        <h6 class="dropdown-header sn-top-dropdown__heading">{{ node.label }}</h6>
        <ng-container *ngTemplateOutlet="items; context: {$implicit: node.children, vm: vm}"></ng-container>
      }
      @if (node.type === 'link') {
      <div class="sn-top-dropdown__row">
        @if (!node.external) {
        <a class="dropdown-item" [class.sn-top-dropdown__item--active]="vm.activeIds.has(node.id)"
           [attr.aria-current]="vm.activeIds.has(node.id) ? 'page' : null"
           [routerLink]="node.path" [queryParams]="node.queryParams" (click)="closeAll()">
          <i class="fa-fw sn-top-dropdown__icon" [class]="node.icon || 'fa-solid fa-circle'" aria-hidden="true"></i>
          <span>{{ node.label }}</span>
        </a>
        }
        @if (node.external) {
        <a class="dropdown-item" [href]="node.href" target="_blank" rel="noopener noreferrer"
           (click)="closeAll()">
          <i class="fa-fw sn-top-dropdown__icon" [class]="node.icon || 'fa-solid fa-circle'" aria-hidden="true"></i>
          <span>{{ node.label }}</span>
          <i class="fa-solid fa-arrow-up-right-from-square sn-top-dropdown__external" aria-hidden="true"></i>
          <span class="visually-hidden"> (opens in a new tab)</span>
        </a>
        }
        <button type="button" class="sn-star" [class.sn-star--on]="isStarred(node, vm.starred)"
                [attr.aria-pressed]="isStarred(node, vm.starred)" [attr.aria-label]="'Favorite ' + node.label"
                [title]="isStarred(node, vm.starred) ? 'Remove from favorites' : 'Add to favorites'"
                (click)="toggleStar(node, $event)">
          <i [class]="isStarred(node, vm.starred) ? 'fa-solid fa-star' : 'fa-regular fa-star'" aria-hidden="true"></i>
        </button>
      </div>
      }
    }
  </ng-template>

  <ng-template #favoriteItems let-favorites>
    @for (favorite of favorites; track trackById($index, favorite); let first = $first; let last = $last) {
    <div
         class="sn-top-dropdown__row sn-top-dropdown__row--favorite">
      @if (renaming === favorite.key) {
      <input #rename class="form-control form-control-sm sn-top-dropdown__rename"
             type="text" maxlength="120" [value]="favorite.label" [attr.aria-label]="'Rename ' + favorite.label"
             (click)="$event.stopPropagation()" (keydown.enter)="finishRename(favorite, rename.value)"
             (keydown.escape)="cancelRename($event)" (blur)="finishRename(favorite, rename.value)">
      }
      @if (renaming !== favorite.key) {
      @if (!favorite.external) {
      <a class="dropdown-item" [routerLink]="favorite.path"
         [queryParams]="favorite.queryParams" (click)="closeAll()">
        <i class="fa-fw sn-top-dropdown__icon" [class]="favorite.icon || 'fa-solid fa-bookmark'" aria-hidden="true"></i>
        <span>{{ favorite.label }}</span>
        @if (favorite.detail) {
        <small class="sn-top-dropdown__detail">{{ favorite.detail }}</small>
        }
      </a>
      }
      @if (favorite.external) {
      <a class="dropdown-item" [href]="favorite.href" target="_blank"
         rel="noopener noreferrer" (click)="closeAll()">
        <i class="fa-fw sn-top-dropdown__icon" [class]="favorite.icon || 'fa-solid fa-bookmark'" aria-hidden="true"></i>
        <span>{{ favorite.label }}</span>
        <span class="visually-hidden"> (opens in a new tab)</span>
      </a>
      }
      <span class="sn-top-dropdown__actions">
        <button type="button" class="sn-icon-button" [attr.aria-label]="'Rename ' + favorite.label"
                title="Rename" (click)="startRename(favorite, $event)">
          <i class="fa-solid fa-pen" aria-hidden="true"></i>
        </button>
        <button type="button" class="sn-icon-button" [disabled]="first" [attr.aria-label]="'Move ' + favorite.label + ' up'"
                title="Move up" (click)="moveFavorite(favorite, -1, $event)">
          <i class="fa-solid fa-arrow-up" aria-hidden="true"></i>
        </button>
        <button type="button" class="sn-icon-button" [disabled]="last" [attr.aria-label]="'Move ' + favorite.label + ' down'"
                title="Move down" (click)="moveFavorite(favorite, 1, $event)">
          <i class="fa-solid fa-arrow-down" aria-hidden="true"></i>
        </button>
        <button type="button" class="sn-icon-button" [attr.aria-label]="'Remove ' + favorite.label + ' from favorites'"
                title="Remove from favorites" (click)="removeFavorite(favorite, $event)">
          <i class="fa-solid fa-xmark" aria-hidden="true"></i>
        </button>
      </span>
      }
    </div>
    }
  </ng-template>

}
